import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', loadComponent: () => import('./features/index/index.component').then(m => m.IndexComponent) },
  { path: 'credential/:id', loadComponent: () => import('./features/credential/credential.component').then(m => m.CredentialComponent) },
  { path: '**', loadComponent: () => import('./features/not-found/not-found.component').then(m => m.NotFoundComponent) },
];
